










import { defineComponent, inject, reactive, ref } from '@vue/composition-api'
import Editor from '@/components/Editor.vue'
import { EntityType } from '@/api/project/model'
import TimeCustomSelect from '@/components/TimeCustomSelect.vue'
export default defineComponent({
    components: {
        Editor,
        TimeCustomSelect
    },
    setup() {
        const itemObj: any = inject('itemObj')
        return {
            itemObj,
            EntityType
        }
    }
})
